module.exports = __webpack_public_path__ + "fd8d498382e68b769f764968caf04c95.MP3";